module.exports = __webpack_public_path__ + "img/green-1-squiggly-open.58f8faf0.svg";